import { useRef, useEffect } from "react";
import { getUrl } from "common/entities";
import { Entity } from "common/entities/types";
import { Site } from "common/types/sites";
import { Link } from "common/widgets/link";
import { ShowMore } from "common/widgets/show-more";
import { ExplorerRecord } from "./types";

interface Props {
  records: ExplorerRecord[];
  entity: Entity;
  site: Site;
  count: number;
  page: number;
  onChangePage: () => void;
}

const DEFAULT_PAGE_SIZE = 25;

export const ExplorerRecords = ({
  records,
  entity,
  site,
  count,
  page,
  onChangePage,
}: Props) => {
  const recordsRef = useRef<HTMLDivElement>(null);

  const scrollToTheBottom = () => {
    const current = recordsRef.current;
    if (current) {
      current.scrollTo({
        top: current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    if (recordsRef.current) {
      scrollToTheBottom();
    }
  }, [records.length]);

  const isLastPage = page * DEFAULT_PAGE_SIZE >= count;
  const recordsList = records.map((r) => (
    <Link
      key={r.id}
      className="x-explorer-link"
      href={`${getUrl(entity, site.name)}/${r.id}`}
    >
      <div>{r.title}</div>
    </Link>
  ));

  return (
    <div className="x-explorer-records">
      {count > records.length && !isLastPage ? (
        <ShowMore action={onChangePage}>
          <div className="x-scrollable" ref={recordsRef}>
            {recordsList}
          </div>
        </ShowMore>
      ) : (
        recordsList
      )}
    </div>
  );
};
